import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {
  private static readonly KEY = CryptoJS.enc.Utf8.parse('9DugdSpLIVa2ob95'); // Clave de 16 bytes
  private static readonly IV = CryptoJS.enc.Utf8.parse('9DugdSpLIVa2ob95'); // IV de 16 bytes

  decrypt(encryptedText: string): string {
    // Convierte el texto cifrado en un objeto WordArray
    const encryptedWordArray = CryptoJS.enc.Base64.parse(encryptedText);

    // Desencripta el objeto WordArray
    const decryptedBytes = CryptoJS.AES.decrypt(
      { ciphertext: encryptedWordArray } as any, // Casting para cumplir con los tipos
      CryptoService.KEY,
      {
        iv: CryptoService.IV,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );

    // Convierte los bytes desencriptados a una cadena UTF-8
    return decryptedBytes.toString(CryptoJS.enc.Utf8);
  }

  // Método para encriptar texto
  encrypt(plainText: string): string {
    // Convierte el texto plano en un objeto WordArray
    const plainWordArray = CryptoJS.enc.Utf8.parse(plainText);

    // Encripta el objeto WordArray
    const encrypted = CryptoJS.AES.encrypt(plainWordArray, CryptoService.KEY, {
      iv: CryptoService.IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    // Convierte el texto cifrado a una cadena Base64
    return encrypted.toString();
  }
}

